import React, { useState } from 'react';
import { db } from '../config/firebaseConfig'; // Firestore’u import et
import { collection, addDoc } from 'firebase/firestore';

const KategoriEkle = () => {
  const [categoryName, setCategoryName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) {
      setError('Kategori adı boş olamaz.');
      return;
    }

    try {
      await addDoc(collection(db, 'blogs', 'eISHrRzWTBUgMyDVL8nq', 'category'), {
        name: categoryName,
        createdAt: new Date().toISOString(),
      });
      setSuccess('Kategori başarıyla oluşturuldu!');
      setCategoryName('');
      setError('');
    } catch (error) {
      setError('Kategori oluşturulurken bir hata oluştu: ' + error.message);
      setSuccess('');
    }
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Kategori Oluştur</h1>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Yeni Kategori Ekle</h6>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="categoryName">Kategori Adı</label>
              <input
                type="text"
                className="form-control"
                id="categoryName"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                placeholder="Kategori adını girin"
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Kategori Oluştur
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default KategoriEkle;